<template>
    <div>
      <div ref="d3_root"></div>

    </div>
</template>

<script>
    import * as d3 from "d3";

    const d3Cloud = require('d3-cloud')
    export default {
        name: "WordCloud",
        props: ['height','width', 'text_size', 'chartData'],
        computed: {
        },
      watch: {
          chartData: function (newValue) {
            if (newValue) this.draw()
          },
        },
        mounted() {
          if (this.chartData) {
            this.draw()
          }
        },
        methods: {
            draw() {

              const cloud = d3Cloud()
                  .size([this.width, this.height])
                  .words(this.chartData)
                  .padding(5)
                  .rotate(function() { return (~~(Math.random() * 6) - 3) * 30; })
                  .font("Impact")
                  .fontSize(function(d) { return 10 * Math.sqrt(d.size); })
                  .on("end", (words) => {
                    const svgElement = document.createElementNS("http://www.w3.org/2000/svg",'svg')
                    const svg = d3.select(this.$refs.d3_root).append('svg')
                        .attr("width", this.width)
                        .attr("height", this.height)
                        .append("g")
                        .attr("transform", "translate(" + this.width / 2 + "," + this.height / 2 + ")")
                        .selectAll("text")
                        .data(words)
                        .enter().append("text")
                        .style("font-size", function(d) { return d.size + "px"; })
                        .style("font-family", "Impact")
                        .attr("text-anchor", "middle")
                        .attr("transform", function(d) {
                          return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
                        })
                        .text(function(d) { return d.text; })
                        .attr("fill", d => {
                          return d.color;
                        })
                        .on("click", (d) => {
                          let node = d
                          let args = []
                          args['label'] = args['word'] = d.text
                          this.$emit('stackChartClicked', args);
                        });
                  });
              while (this.$refs.d3_root.firstChild) {
                this.$refs.d3_root.removeChild(this.$refs.d3_root.firstChild);
              }
              cloud.start()

            }
        }
    }
</script>

<style scoped>

</style>